import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';

@Component({
    selector: 'alphabet-search',
    templateUrl: './alphabet-search.component.html',
    styleUrls: ['./alphabet-search.component.scss']
})
export class AlphabetSearchComponent extends BaseComponent {

    @Input()
    public letter: string;

    @Output()
    public letterChange = new EventEmitter<string>();


    public readonly lettersInRows = ['ABCDEFGHIJKLM', 'NOPQRSTUVWXYZ'];

    constructor() {
        super();
        this._idPrefix = 'alphabet_search.';
    }

    public selectLetter(letter: string) {
        this.letterChange.emit(letter);
    }
}
